import { render } from "./wfm-docp-file.vue?vue&type=template&id=2bec545f&scoped=true"
import script from "./wfm-docp-file.vue?vue&type=script&lang=js"
export * from "./wfm-docp-file.vue?vue&type=script&lang=js"

import "./wfm-docp-file.vue?vue&type=style&index=0&id=2bec545f&lang=css"
import "./wfm-docp-file.vue?vue&type=style&index=1&id=2bec545f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bec545f"]])

export default __exports__